import $ from 'jquery';

import webApp from './webApp';
import issueCache from './issueCache';
import analytics from './analytics';
import i18n from './i18n';

let attemptedReloadAfter403 = false;

// -------------- Hooks --------------

webApp.hooks.addAction( 'reader_opened', 'asmag_web_app', ( issue ) => {
  $( document.body ).on( 'click', 'a', onClickLink );
}, 5 );

webApp.hooks.addAction( 'reader_closed', 'asmag_web_app', ( issue ) => {
  $( document.body ).off( 'click', onClickLink );
}, 100 );

webApp.hooks.addAction( 'reader_opened', 'asmag_web_app', ( issue ) => {
  if ( !issue.permissions.read ) {
    // If the user has no access to the issue, we don't want to show any 
    // cached pages from localStorage. The user might have full versions of 
    // the pages in localStorage if he accessed the issue earlier on with 
    // reading privileges, and after that without reading privileges.
    //
    // It'd look weird with the full content of the pages visible but with a 
    // small paywall on top of it. Therefore we clear the whole issue cache, so
    // that the reading view will only show previews of the pages, not full versions.
    //
    issueCache.clearCacheForIssue( issue.id );
  }
} );

// Update the browser URL for the new page
webApp.hooks.addAction( 'reader_page_index_changed', 'asmag_web_app', ( oldIndex, currentIndex, oldPage, currentPage ) => {

  if ( window.location.href !== currentPage.permalink ) {
    // Set this to `true` if you want the browser back button to cause the reader
    // to flip to the previous issue page, instead of closing the issue
    const historyMethod = ( webApp.hooks.applyFilters( 'browser_back_button_goes_to_previous_issue_page', false ) )
      ? 'pushState'
      : 'replaceState';

    let url = currentPage.permalink;

    // Always preserve query vars in the URL, so that a possible issue share token
    // or page share token don't disappear if the user refreshes the browser page
    if ( window.location.search ) {
      if ( url.indexOf( '?' ) === -1 )
        url += window.location.search;
      else
        url += '&'+ window.location.search.substr( 1 );
    }

    window.history[ historyMethod ]( {
      issueId: webApp.issueReader.issue.id,
      pageId: currentPage.id
    }, '', url );
  }

  document.title = currentPage.title +' - '+ webApp.issueReader.issue.name +' - '+ webApp.env.site_name;
} );

/**
 * Try to reload issue after a 403; the issue page's download URL is 
 * possibly expired, so we'll reload to get fresh download URLs.
 */
webApp.hooks.addAction( 'reader_page_load_error', 'asmag_web_app', ( error ) => {
  var jqXhr = ( error && error.statusText ) ? error : null;

  // Ignore aborts and timeouts
  if ( jqXhr && ( jqXhr.statusText === 'abort' || jqXhr.statusText === 'timeout' ) )
    return;

  // If the user has no permission to access the issue, we assume that
  // the page loader token embedded in the page HTML URL has expired, and we
  // must reload the browser to get newer page HTML URLs from the backend
  if ( jqXhr && jqXhr.status == 403 && !attemptedReloadAfter403 ) {
    attemptedReloadAfter403 = true;
    window.location.reload();
  }
} );

/**
 * Update <a class="shareMail"> links to contain the current page's info
 * whenever a new page is shown.
 * TODO: deprecate and remove this hack, and figure out a cleaner approach.
 */
webApp.hooks.addAction( 'reader_page_shown', 'asmag_web_app', () => {

  var issueName = webApp.issueReader.issue.name;
  var page = webApp.issueReader.issue.pages[ webApp.issueReader.pageIndex ];

  $( '#asmag-issue a.shareEmail' ).
    attr(
      'href',
      "mailto:?subject=" +
        encodeURIComponent(page.title +' - '+ issueName +' - '+ webApp.env.site_name) +
        "&body=" +
        encodeURIComponent(i18n.strings.base.ui.sharemailprelink + page.share_url + i18n.strings.base.ui.sharemailaftlink)
    ).
    off( 'click.asmag_sharemailto' ).
    on( 'click.asmag_sharemailto', function() {
      var issueId = webApp.issueReader.issue.id;
      var issuePrice = webApp.issueReader.issue.paid ? 'paid' : 'free';
      var issueTags = webApp.issueReader.issue.tags || [];
      var pageId = webApp.issueReader.issue.pages[ webApp.issueReader.pageIndex ].id;

      analytics.sendEvent( 'AsteikkoMag', 'Share', 'E-mail', undefined, issueId, pageId, issuePrice, issueTags.join( ',' ) );
    } );

} );


// -------------- Helper functions --------------

function onClickLink( event ) {
  var href = $( this ).attr( 'href' ) || '';

  // Ignore links that start with a hash
  if ( href.indexOf( '#' ) === 0 )
    return true;

  if ( webApp.issueReader.goToPageByPermalink( href ) ) {
    event.preventDefault();
    return false;
  }

  var issueId = webApp.issueReader.issue.id;
  var issuePrice = webApp.issueReader.issue.paid ? 'paid' : 'free';
  var issueTags = webApp.issueReader.issue.tags || [];
  var pageId = webApp.issueReader.issue.pages[ webApp.issueReader.pageIndex ].id;

  analytics.sendEvent( 'AsteikkoMag', 'Open link', href, undefined, issueId, pageId, issuePrice, issueTags.join( ',' ) );

  return true;
}
